module.exports = __webpack_public_path__ + "/build/web/images/exclusive-collection@3x.345e33c267110dd56832b90be060ba1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/exclusive-collection@3x.jpg
// module id = 129
// module chunks = 13